import React, { createContext, useContext, useState, PropsWithChildren } from "react"

interface LoadingContextProps {
  isLoading: boolean
  startLoading: () => void
  stopLoading: () => void
}

const LoadingContext = createContext<LoadingContextProps | undefined>(undefined)

export const LoadingProvider: React.FC<PropsWithChildren<{ children: React.ReactNode }>> = ({ children }) => {
  const [loadingCount, setLoadingCount] = useState(0)

  const startLoading = () => {
    setLoadingCount((prevCount) => prevCount + 1)
  }

  const stopLoading = () => {
    setLoadingCount((prevCount) => Math.max(prevCount - 1, 0))
  }

  const isLoading = loadingCount > 0

  return <LoadingContext.Provider value={{ isLoading, startLoading, stopLoading }}>{children}</LoadingContext.Provider>
}

export const useLoading = () => {
  const context = useContext(LoadingContext)
  if (!context) {
    throw new Error("useLoading must be used within a LoadingProvider")
  }
  return context
}
